import angular from 'angular'
import dcStringToNumber from './string-to-number.directive'
export default angular.module( 'directives.stringtonumber', [] )
    .directive( 'stringToNumber', dcStringToNumber );
